import { render, staticRenderFns } from "./DeckItem.vue?vue&type=template&id=3fc7648a&scoped=true"
import script from "./DeckItem.vue?vue&type=script&lang=js"
export * from "./DeckItem.vue?vue&type=script&lang=js"
import style0 from "./DeckItem.vue?vue&type=style&index=0&id=3fc7648a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc7648a",
  null
  
)

export default component.exports